import { useState } from "react";
import { Bell, Check } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function NotifyMe({ productId }) {
  const { user } = useAuth();
  const [email, setEmail] = useState(user?.email || "");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post(`/products/${productId}/notify-me`, { email });
      setDone(true);
      toast.success("We'll email you when it's back");
    } catch {
      toast.error("Please enter a valid email");
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div className="mt-6 flex items-center gap-3 border border-[#D4AF37]/40 bg-[#FDFBF7] px-5 py-4 text-sm text-stone-700" data-testid="notify-me-success">
        <Check size={16} className="text-[#D4AF37]" /> You're on the list — we'll email {email} when it returns.
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="mt-6 border border-warm bg-white px-5 py-5 rounded-sm" data-testid="notify-me-form">
      <div className="flex items-center gap-2 text-[11px] tracking-overline uppercase text-[#5A1618]">
        <Bell size={14} /> Notify me when back in stock
      </div>
      <div className="mt-4 flex flex-col sm:flex-row gap-3">
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email"
               className="flex-1 bg-transparent border-b border-warm focus:border-[#D4AF37] outline-none py-2 text-sm"
               data-testid="notify-me-email" />
        <button type="submit" disabled={busy} className="btn-ink justify-center disabled:opacity-50" data-testid="notify-me-submit">
          {busy ? "Saving..." : "Notify Me"}
        </button>
      </div>
    </form>
  );
}
